export enum TradingType {
  Buy = 1,
  Sell = 2,
}
